import Vue from "vue";
import Vuex from "vuex";
import VueCookies from "vue-cookies";
import { http } from "@/request/api";
Vue.use(Vuex);
import Layout from "@/components/index";
import { Message } from "element-ui";

import { setCookie,delCookieInfos } from "@/utils/util.js";

let lifeData = {};

try {
  // 尝试获取本地是否存在lifeData变量，第一次启动时是不存在的
  lifeData = localStorage.getItem("lifeData")
    ? JSON.parse(localStorage.getItem("lifeData"))
    : {};
  console.log("localStorage.lifeData: ", lifeData);
} catch (e) {
  console.log(e);
}

// 需要永久存储，且下次启动需要取出的，在state中的变量名
let saveStateKeys = ["vuex_id", "vuex_index", "vuex_type", "vuex_antRouter"];

// 保存变量到本地存储中
const saveLifeData = function (key, value) {
  // 判断变量名是否在需要存储的数组中
  if (saveStateKeys.indexOf(key) !== -1) {
    // 获取本地存储的lifeData对象，将变量添加到对象中
    let tmp = JSON.parse(localStorage.getItem("lifeData"));
    // 第一次打开APP，不存在lifeData变量，故放一个{}空对象
    tmp = tmp ? tmp : {};
    tmp[key] = value;
    // 执行这一步后，所有需要存储的变量，都挂载在本地的lifeData对象中
    localStorage.setItem("lifeData", JSON.stringify(tmp));
  }
};
const store = new Vuex.Store({
  state: {
    //需要永久保存的数据要加入lifeData对象antRouter
    vuex_antRouter: [],
    vuex_id: lifeData.vuex_id ? lifeData.vuex_id : "/home",
    vuex_index: lifeData.vuex_index ? lifeData.vuex_index : 0,
    vuex_type: lifeData.vuex_type ? lifeData.vuex_type : 0,
    vuex_Token: VueCookies.get("userToken")
      ? VueCookies.get("userToken")
      : null,
    vuex_User: VueCookies.get("userInfo") ? VueCookies.get("userInfo") : null,
    screen: -1,
    isCollapse: false,
    platform: process.env.PLATFORM,
    SANYA: process.env.SANYA,
    ZHANJIANG: process.env.ZHANJIANG
  },

  //https://blog.csdn.net/qq_40117020/article/details/108265743
  mutations: {
    SET_SCREEN: (state, screen) => {
      state.screen = screen;
    },
    SET_COLLAPSE: state => {
      state.isCollapse = !state.isCollapse;
    },
    $mcStore(state, payload) {
      // 判断是否多层级调用，state中为对象存在的情况，诸如user.info.score = 1
      let nameArr = payload.name.split(".");
      let saveKey = "";
      let len = nameArr.length;
      if (len >= 2) {
        let obj = state[nameArr[0]];
        for (let i = 1; i < len - 1; i++) {
          obj = obj[nameArr[i]];
        }
        obj[nameArr[len - 1]] = payload.value;
        saveKey = nameArr[0];
      } else {
        // 单层级变量，在state就是一个普通变量的情况
        state[payload.name] = payload.value;
        saveKey = payload.name;
      }
      // 保存变量到本地，见顶部函数定义
      saveLifeData(saveKey, state[saveKey]);
      console.log(state, "statestate");
    }
  },
  actions: {
    GenerateRoutes({ commit }, payload) {



      /**
       * 对象深拷贝
       */
      const deepClone = data => {
        var type = getObjType(data);
        var obj;
        if (type === "array") {
          obj = [];
        } else if (type === "object") {
          obj = {};
        } else {
          //不再具有下一层次
          return data;
        }
        if (type === "array") {
          for (var i = 0, len = data.length; i < len; i++) {
            obj.push(deepClone(data[i]));
          }
        } else if (type === "object") {
          for (var key in data) {
            obj[key] = deepClone(data[key]);
          }
        }
        return obj;
      };
      const getObjType = obj => {
        var toString = Object.prototype.toString;
        var map = {
          "[object Boolean]": "boolean",
          "[object Number]": "number",
          "[object String]": "string",
          "[object Function]": "function",
          "[object Array]": "array",
          "[object Date]": "date",
          "[object RegExp]": "regExp",
          "[object Undefined]": "undefined",
          "[object Null]": "null",
          "[object Object]": "object"
        };
        if (obj instanceof Element) {
          return "element";
        }
        return map[toString.call(obj)];
      };
      return new Promise(resolve => {
        // 向后端请求路由数据
        http.menuRoutes().then(async res => {
          var routers = res.data instanceof Array ? res.data : [];

          console.log(routers, "routersxxx");
          if (routers.length == 0) {
            //按照需求跳转到登录页面
            Message({
              message: "请求超时，请重新登录",
              type: "error",
              duration: 1000
            });
            // VueCookies.set("userToken", null,domain = domainInfo());
            setCookie("userToken",null);
            delCookieInfos();
            //set(keyName: string, value: any, expireTimes?: string | number | Date,path?: string, domain?: string, secure?: boolean, sameSite?: string)
            setTimeout(() => {
              window.location.href = process.env.LOGINIURL;
            }, 1000);
            return;
          }

          var oldArr = [];
          var roleName = VueCookies.get("roleName");
          routers.findIndex(item => {
            if (item.name == "平台综合路由") {
              item.children.map(v => {
                var name = v.name.substring(0, 4)
                console.log(v, "vvvvvvvvvvvvv", name);
                if (name.indexOf(roleName) > -1 && v.children) {
                  v.children.map(it => {
                    oldArr.push(it);
                  });
                }
              });
            }
          });
          console.log(oldArr, "oldArroldArroldArr");
          //   var newfilterAsyncRoutesArr = newfilterAsyncRoutes(res.data, getusername())
          //   localStorage.setItem("hasPermission", newfilterAsyncRoutesArr)
          var arr = oldArr;
          function getallData(arr, allData = []) {
            arr.map(item => {
              allData.push(item);
              if (item && item.children && item.children.length) {
                getallData(item.children, allData);
              }
            });
            return allData;
          }
          var getallDatas = getallData(arr);
          getallDatas.map(item => {
            item.group = [item.path];
            getallDatas.map(v => {
              if (item.id == v.parentId) {
                item.group.push(v.path);
              }
            });
          });
          routers = await filterAsyncRouter(deepClone(arr));

          var accessedRoutes = await filterAsyncRouter(deepClone(arr));
          console.log(routers, "routersroutersrouters");
          routers.push(
            {
              path: "/404",
              component: () => import("@/bureau_education/404"),
              hidden: true,
              meta: {
                icon: "#",
                title: ""
              }
            },
            {
              path: "*",
              component: () => import("@/bureau_education/404"),
              meta: {
                icon: "#",
                title: ""
              },
              hidden: true
            }
          );
          await commit("$mcStore", {
            name: "vuex_antRouter",
            value: accessedRoutes
          });

          resolve(routers);
        });
      });
    }
  },
  getters: {
    screen: state => state.screen,
    keyCollapse: (state, getters) =>
      getters.screen > 1 ? getters.isCollapse : false,
    isCollapse: state => state.isCollapse
  }
});
// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, name = null, group = []) {
  return asyncRouterMap.map(route => {
    // route.hidden=false;
    // if(route.name.indexOf("none")>-1){
    //   console.log(route.name,'namesxxxxxxxxx')
    //   route.hidden=true
    // }
    if (route && route.alias) {
      if (route.alias == "Layout") {
        route.component = Layout;
      } else {
        route.component = loadView(route.alias);
      }
      route.redirect = route.code == "none" ? null : route.code;
      if (route.children != null && route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, route.name, group);
      }
    }
    return {
      redirect: route.redirect || null,
      path: route.path,
      children: route.children || [],
      component: route.component,
      name: route.name,
      source: route.source,
      componentURL: `@/views/${route.alias}`,
      group: route.group,
      // hidden:route.hidden
    };
  });
}
export const loadView = view => {
  // 路由懒加载
  // var obj = {
  //   学校端: "school",
  //   教育局: "views",
  //   区教育局: "eduviews",
  //   教师端: "teacher",
  //   招聘专员: "zhaopin" 
  //   班主任: "class_teacher",
  // };
  // var roleName = VueCookies.get("roleName");
  var roleAlias = VueCookies.get("roleAlias");
  // var arr=Object.keys(obj)
  // var index=arr.findIndex(v=>v.indexOf(roleName)>-1)
  // return resolve => require([`@/${obj[arr[index]]}/${view}`], resolve);
  return resolve => require([`@/${roleAlias}/${view}`], resolve);
};

// 菜单权限
// function newhasPermission(roles, route) {
//   if (route && route.meta && route.meta.rules) {
//     return route.meta.rules.includes(roles);
//   } else {
//     return false;
//   }
// }

// export function newfilterAsyncRoutes(routes, roles) {
//   const res = [];
//   routes.forEach(route => {
//     const tmp = { ...route };
//     if (newhasPermission(roles, tmp)) {
//       if (tmp.children) {
//         tmp.children = newfilterAsyncRoutes(tmp.children, roles);
//       }
//       res.push(tmp);
//     }
//   });

//   return res;
// }
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js